import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  InputContainer,
  ResultsContainer,
  ImageContainer,
  DescriptionContainer,
  FormulaPrintModalContainer,
} from '../template/FormulaFormTemplates';
import { DryHydrantVM } from './DryHydrantVM';
import { ComboBox } from 'cd-eft/components/common/ComboBox';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdflogo from 'cd-eft/assets/images/pdf-blue.svg';



const DryHydrantComponent = (props) => {
  const vm = useRef(new DryHydrantVM(props)).current;
  useEffect(() => {
    // on initial render, load form data - desc, img, help link
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
  }, []);
  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />    
      <div className="formula-content row ">    
        <InputContainer computeCallback={() => {vm.computeDryHydrant()}} printCallback={() => {vm.launchAndExport()}} disableCompute={vm.disableComputeBtn} disablePrint={vm.disablePrintBtn || vm.isLoading} isLoading={vm.isLoading}>
          <span className="input-help-header">
            <a href={vm.helpLink} target='_blank'>Help select C value <img src={pdflogo} alt={'PDF logo'} /></a>
          </span>
          <h2 className='sections-heading'>General</h2>
          <Input
            label="Water Needed (gpm)"
            idAndName="water-needed"
            valid={!vm.formValidation.waterNeeded}
            value={vm.dryHydrantForm.waterNeeded}
            className={vm.DryHydrantErrorClass('waterNeeded')}
            type="number"
            step={'0.01'}
            onKeyDown={vm.handleOnKeyDown}
            min={250}
            onChange={(e) => { vm.handleDryHydrantForm(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          />

        <h2 className='sections-heading'>Pipeline</h2>
          <Input
            label="Total Pipe Length (ft)"
            idAndName="total-pipe-length"
            valid={!vm.formValidation.totalPipeLength}
            value={vm.dryHydrantForm.totalPipeLength}
            className={vm.DryHydrantErrorClass('totalPipeLength')}
            type="number"
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onChange={(e) => { vm.handleDryHydrantForm(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          />
          <ComboBox
            idAndName="pipe-diameter"
            label="Pipe Diameter (in)"
            aria-label="pipe-diameter"
            valid={!vm.formValidation.pipeDiameter}
            value={vm.dryHydrantForm.pipeDiameter}
            onChange={(e) => {
              vm.handleDryHydrantForm(e);
            }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            options={vm.pipeDiameterOptions}
            errorMsg={''}
            required={true}
            className={`pipe-diameter${vm.DryHydrantErrorClass('pipeDiameter')}`}
          />
          <Input
            label="Hazen-Williams Coefficient (C)"
            idAndName="hazen-williams-coefficient"
            valid={!vm.formValidation.hazenWilliamsCoefficient}
            value={vm.dryHydrantForm.hazenWilliamsCoeff}
            className={vm.DryHydrantErrorClass('hazenWilliamsCoefficient')}
            type="number"
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onChange={vm.handleDryHydrantForm}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          />
          <Input
            label="Number of 90&deg; Elbows"
            idAndName="ninety-degree-elbow"
            valid={!vm.formValidation.numberof90Elbows}
            value={vm.dryHydrantForm.numberOf90Elbows}
            className={vm.DryHydrantErrorClass('numberof90Elbows')}
            type="number"
            step={1}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
            onChange={(e) => { vm.handleDryHydrantForm(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          />
          <Input
            label="Number of 45&deg; Elbows"
            idAndName="forty-five-degree-elbow"
            valid={!vm.formValidation.numberof45Elbows}
            value={vm.dryHydrantForm.numberOf45Elbows}
            className={vm.DryHydrantErrorClass('numberof45Elbows')}
            type="number"
            step={1}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
            onChange={vm.handleDryHydrantForm}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          />

          <h2 className='sections-heading'>Elevations</h2>
          <Input
            label="Pump Centerline Elevation (ft)"
            idAndName="pump-centerline-elevation"
            valid={!vm.formValidation.pumpCenterlineElevation}
            value={vm.dryHydrantForm.pumpCenterlineElev}
            className={vm.DryHydrantErrorClass('pumpCenterlineElevation')}
            type="number"
            step={'0.01'}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onChange={(e) => { vm.handleDryHydrantForm(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}

          />
          <Input label="Hydrant Centerline Elevation (ft)"
            idAndName="hydrant-centerline-elevation"
            valid={!vm.formValidation.hydrantCenterlineElevation}
            value={vm.dryHydrantForm.hydrantCenterlineElev}
            className={vm.DryHydrantErrorClass('hydrantCenterlineElevation')}
            type="number"
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onChange={vm.handleDryHydrantForm}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          />
          <Input
            label="Normal Water Elevation (ft)"
            idAndName="normal-water-elevation"
            valid={!vm.formValidation.normalWaterElevation}
            value={vm.dryHydrantForm.normalWaterElev}
            className={vm.DryHydrantErrorClass('normalWaterElevation')}
            type="number"
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onChange={vm.handleDryHydrantForm}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          />
          <Input
            label="Inlet Centerline Elevation (ft)"
            idAndName="inlet-centerline-elevation"
            valid={!vm.formValidation.inletCenterlineElevation}
            value={vm.dryHydrantForm.inletCenterlineElev}
            className={vm.DryHydrantErrorClass('inletCenterlineElevation')}
            type="number"
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onChange={(e) => { vm.handleDryHydrantForm(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
          />

        </InputContainer >
        <div className="col formula-information">
          {vm.hasResults  ? (
            <div className="row formula-results">
              <ResultsContainer>
                  <div className="result-value-group">
                    <div className="row constricted-row">
                      <div className="col-auto result-label">Total Head Loss (ft):</div>
                      <div className="col-auto result-value">{vm?.dryHydrantResults?.headLoss}</div>
                    </div>
                    <div className="col-md-12 sections-heading">Materials Needed:</div>    
                    <ul>        
                    {vm?.dryHydrantResults?.materials?.split("\n").filter((item) => item !== "").map((item, index) => (
                         <li key={`${item}-${index}`} className="usa-list--unstyled col-md-12 ">{item}</li>
                     ))}
                     </ul>
                  </div>
              </ResultsContainer>
            </div>
        ) : ''}
          <div className="row formula-description">
            <DescriptionContainer>
              <p> 
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdflogo} alt={'PDF logo'} />
                </a>        
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
          
            <ImageContainer>
              <img
                className=""
                src={vm.image}
                alt={vm.hydraulicFormulaImageDescription}
                title={vm.formulaTitle}
              />
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer 
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  );
};

export const DryHydrantFormula = observer(DryHydrantComponent);